import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/services/data.service';
import { UserPreferenceService } from 'src/app/services/user-preference.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-content-delete-modal',
    templateUrl: './content-delete-modal.component.html',
    styleUrls: ['./content-delete-modal.component.scss'],
    standalone: false
})
export class ContentDeleteModalComponent implements OnInit {
  @Input() id: any;
  @Input() user_id: any;
  @Input() pagename: string = 'Content';
  
  dontShowAgain: boolean = false;
  isLoading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private dataService: DataService,
    private userPreferenceService: UserPreferenceService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}

  confirm() {
    this.isLoading = true;
    
    if (this.dontShowAgain) {
      this.userPreferenceService.updatePreference(this.user_id, 'hide_content_delete_confirmation', true).subscribe(() => {
        this.cdr.detectChanges();
      });
    }

    this.dataService.deleteContentById(this.id, this.user_id).subscribe(
      (res) => {
        this.isLoading = false;
        this.cdr.detectChanges();
        if (res) {
          this.toastService.showSuccess('Content deleted.', 'success');
          this.activeModal.close(true);
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Error deleting content', error);
      
          this.cdr.detectChanges();}
    );
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
